/* @flow */
import * as React from 'react';

import { Button, ButtonIcon, Footer, Page, PageContainer, Panel, genRuby } from '@sonyged/ext-proc';

import { type NewRound } from './domain/Round';
import { StoreTalkBubble, StoreTalkBubbleArrow } from './StoreTalkBubble';
import AutoScaleContainer from './AutoScaleContainer';
import PizzaCustomer from './PizzaCustomer';

type Props = {
  round: NewRound,
  randomize?: () => void,
  onBack?: () => void,
  onNext: () => void,
};

class PizzaResearchTopView extends React.Component<Props> {
  render() {
    const {
      round: { customers },
    } = this.props;
    return (
      <div className="pizza-research-topview top gray5-bg-color">
        <Page.normal>
          <PageContainer.normal className="flex flex-column">
            <div className="pizza-research-topview-content">
              <div className="title">
                <div className="proc-medium-font secondary100-color">しらべる</div>
                {this.props.randomize ? (
                  <div className="proc-huge-font secondary100-color">この おきゃくさんが くるよ。</div>
                ) : (
                  <div className="proc-huge-font secondary100-color">
                    {genRuby('[同|おな]じ おきゃくさんが くるよ。')}
                  </div>
                )}
              </div>

              <Panel.vertical className="customer-info secondary30-border-color">
                <AutoScaleContainer
                  className="tertiary100-bg-color"
                  preferedWidth={864}
                  preferedHeight={474}
                  preferedMinHeight={474}
                >
                  <StoreTalkBubble>{customers[0].talk()}</StoreTalkBubble>
                  <PizzaCustomer talking={true} customer={customers[0]} position="center">
                    <StoreTalkBubbleArrow />
                  </PizzaCustomer>
                </AutoScaleContainer>
              </Panel.vertical>
            </div>

            {this.props.randomize && (
              <Footer.normal className="inner-footer" shadow={false}>
                <Button.normal className="double" onClick={this.props.randomize}>
                  ちがう おきゃくさんで しらべる
                </Button.normal>
              </Footer.normal>
            )}
          </PageContainer.normal>
        </Page.normal>
        <Footer.nav
          shadow={false}
          navItem={
            this.props.onBack ? (
              <Button.normal onClick={this.props.onBack}>
                <ButtonIcon.back />
              </Button.normal>
            ) : null
          }
        >
          <Button.attention onClick={this.props.onNext}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }
}

export default PizzaResearchTopView;
